import { render, staticRenderFns } from "./ServiceShop.vue?vue&type=template&id=afe24590"
import script from "./ServiceShop.vue?vue&type=script&lang=js"
export * from "./ServiceShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports